import { BaseClient } from './BaseClient'
import { MockClient } from './MockClient'
import { WebClient } from './WebClient'

export const getClientInstance = (token?: string)  => {
    let client: BaseClient;

    if (process.env.VUE_APP_CLIENT_TYPE == 'mock') {
        client = MockClient.getInstance()
    }
    else {
        client = WebClient.getInstance(token)
    }

    return client
} 

export const getClient = (token?: string)  => {
    let client: BaseClient;

    if (process.env.VUE_APP_CLIENT_TYPE == 'mock') {
        client = new MockClient()
    }
    else {
        client = new WebClient(token)
    }

    return client
} 

export const createClientInstance = (token: string)  => {
    if (process.env.VUE_APP_CLIENT_TYPE == 'mock') {
        MockClient.createInstance()
    }
    else {
        WebClient.createInstance(token)
    }
} 